import React, { useEffect, useState } from 'react'
import ReactDOM from 'react-dom'
import mapboxgl from 'mapbox-gl'
import 'mapbox-gl/dist/mapbox-gl.css'
import brok from 'brokjson'
import { InteractionToggle } from './interactionToggle.js'
import Popup from '../popup'
import categories from '../main/categories.js'
import { ActivationButton } from './activationButton.js'

import './style.scss'

function AnimatedMap(props) {
  const [mapObject, setMapObject] = useState(null)

  const setInteractivity = enabled => {
    if (!mapObject) return

    if (enabled) {
      mapObject.scrollZoom.enable()
      mapObject.boxZoom.enable()
      mapObject.dragRotate.enable()
      mapObject.dragPan.enable()
      mapObject.keyboard.enable()
      mapObject.doubleClickZoom.enable()
      mapObject.touchZoomRotate.enable()
    } else {
      mapObject.scrollZoom.disable()
      mapObject.boxZoom.disable()
      mapObject.dragRotate.disable()
      mapObject.dragPan.disable()
      mapObject.keyboard.disable()
      mapObject.doubleClickZoom.disable()
      mapObject.touchZoomRotate.disable()
    }
  }

  useEffect(() => {
    const map = new mapboxgl.Map({
      container: 'map',
      style: require('./style.json'),
      center: [7.73497001, 47.46218617],
      zoom: 10,
      minZoom: 8,
      maxZoom: 18,
      interactive: true
    })

    // Return map object
    props.getMapObject(map)

    // Add controls
    const navigationControl = new mapboxgl.NavigationControl({
      showCompass: false
    })

    map.addControl(navigationControl, 'top-right')

    map.activateMap = function() {
      this.scrollZoom.enable()
      this.boxZoom.enable()
      this.dragRotate.enable()
      this.dragPan.enable()
      this.keyboard.enable()
      this.doubleClickZoom.enable()
      this.touchZoomRotate.enable()
    }

    map.deactivateMap = function() {
      this.scrollZoom.disable()
      this.boxZoom.disable()
      this.dragRotate.disable()
      this.dragPan.disable()
      this.keyboard.disable()
      this.doubleClickZoom.disable()
      this.touchZoomRotate.disable()
    }

    map.deactivateMap()

    const interactionControl = new InteractionToggle(map, [
      'Karte aktivieren',
      'Scrollen aktivieren'
    ])
    map.addControl(interactionControl, 'top-right')

    setInteractivity(false)

    setMapObject(map)

    // Initial adjustments
    map.once('load', () => {
      // Add ZH Outline
      map.addSource('outline', {
        type: 'geojson',
        data: require('../data/outline.geojson')
      })

      map.addLayer({
        id: 'outline',
        type: 'fill',
        source: 'outline',
        paint: {
          'fill-color': '#fff',
          'fill-opacity': 1
        }
      })

      map.addLayer({
        id: 'outline2',
        type: 'line',
        source: 'outline',
        paint: {
          'line-color': '#dddddd',
          'line-width': 2
        }
      })

      map.addSource('data', {
        type: 'geojson',
        data: brok.brok2geo(require('../data/data.brokjson'))
      })

      const colorDividor = ['match', ['get', 'category']]
      for (const i in categories) {
        const cat = categories[i]
        colorDividor.push(cat.ident)
        colorDividor.push(cat.color)
      }
      colorDividor.push('red')

      map.addLayer({
        id: 'data',
        type: 'circle',
        source: 'data',
        paint: {
          'circle-radius': {
            base: 1,
            stops: [
              [8, 5],
              [18, 15]
            ]
          },
          'circle-color': colorDividor,
          'circle-stroke-width': 1,
          'circle-stroke-color': '#fff'
        }
      })

      // Add Popup
      map.on('click', 'data', e => {
        if (e && e.features && e.features[0].properties) {
          const props = e.features[0].properties

          const placeholder = document.createElement('div')
          ReactDOM.render(<Popup {...props} />, placeholder)
          map.popup = new mapboxgl.Popup()
          map.popup
            .setDOMContent(placeholder)
            .setLngLat(e.lngLat)
            .addTo(map)
        }
      })

      // Fit Map
      map.fitBounds(
        [
          [7.3117, 47.294],
          [8.2095, 47.634]
        ],
        { duration: 0 }
      )

      // On Load Callback
      if (props.onLoad) {
        props.onLoad()
      }
    })
  }, [])

  return (
    <>
      {mapObject && (
        <div className='activateDesktop'>
          <ActivationButton
            activate={() => mapObject.activateMap()}
            deactivate={() => mapObject.deactivateMap()}
            initialState={null}
            buttonText={['Karte aktivieren', 'Scrollen aktivieren']}
            icons={['moving.svg', 'scrolling.svg']}
          />
        </div>
      )}
      <div id='map'>{props.children}</div>
    </>
  )
}

export default AnimatedMap
